import { createContext, useContext } from 'react';

const emptyShowSeasonContextValue = {
    seasonID: null,
    seasonModelIdSet: new Set(),
    onAddModel: () => {},
    onAddAllModels: () => {},
    addingAllModels: false,
};

export const ShowSeasonContext = createContext(emptyShowSeasonContextValue);

export function useShowSeasonContext() {
    return useContext(ShowSeasonContext);
}
